import { SidebarFeatureEnum } from 'config/types/sidebar'
import { ColumnCenter } from 'layout/Components/Column'
import { useTranslation } from 'react-i18next'
import { useToggleSidebar } from 'state/app/hooks'
import styled from 'styled-components'
import colors from 'theme/ui/colors'
import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Button from 'UIKit/Button'
import Image from 'UIKit/Image'
import NoticeBadge from './NoticeBadge'

export const SidebarToggle: React.FC = () => {
  const { openSidebar, isSidebarOpen, featureActive } = useToggleSidebar()

  return (
    <Container id="sidebar-openProcessSideBar" $Open={isSidebarOpen}>
      <ColumnCenter
        height="56px"
        width="56px"
        style={{ gap: '4px' }}
        background={colors.background}
        borderTopLeftRadius="8px"
        borderBottomLeftRadius="8px"
        justifyContent="center !important"
        position="relative"
      >
        <FeatureToggle
          onClick={() => openSidebar(SidebarFeatureEnum.Tournament)}
          isActive={featureActive === SidebarFeatureEnum.Tournament}
          feature={SidebarFeatureEnum.Tournament}
          tooltipContent="Tournament"
          icon="/images/tournament/tournament-icon.png"
          id="toggle-tournament"
        />

        {/* TODO: Add other features with Feature Toggle */}
      </ColumnCenter>
    </Container>
  )
}

type FeatureToggleProps = {
  onClick: () => void
  isActive: boolean
  feature: SidebarFeatureEnum
  tooltipContent: string
  icon: string
} & BoxProps

const FeatureToggle: React.FC<FeatureToggleProps> = ({
  onClick,
  isActive,
  feature,
  tooltipContent,
  icon,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <StyledButton
      variant="text"
      onClick={onClick}
      data-tooltip-id="common-tip-left"
      data-tooltip-content={t(tooltipContent)}
      $active={isActive}
      {...props}
    >
      <Box width={32} height={32}>
        <Image src={icon} width={32} height={32} />
      </Box>
      <NoticeBadge feature={feature} />
    </StyledButton>
  )
}

const Container = styled(Box)<{ $Open: boolean }>`
  position: absolute;
  z-index: 99;
  top: calc(${({ theme: { topbarHeight } }) => topbarHeight} + var(--notification-bar-height) + 24px);
  right: var(--scrollbar-width);
  width: 56px;
  height: 56px;
  padding: 0px;
  transition: ${({ theme: { transitions } }) => transitions.fast};
  display: none;

  ${({ theme: { mediaQueries } }) => mediaQueries.sm} {
    display: block;
  }
`

const StyledButton = styled(Button)<{ $active: boolean }>`
  width: 40px;
  height: 40px;
  padding: 0px !important;
  border-radius: 4px;
  position: relative;
  background: ${({ $active, theme: { colors } }) => ($active ? colors.backgroundAlt8 : 'transparent')};
  &:hover:not(:disabled):not(:active) {
    transition: none;
    transform: none;
  }
`
